import i18n from 'i18next'

import { TContent, TTranslationSchema } from '@/config/types'
import { isLanguage, Languages } from '@/enums/languages'

import { plans } from './planDetails'

export const contentDetails: Array<TContent> = []

const configPrices = window.config.CONTENT_PRICES || []

const translateBackendData = (data: TTranslationSchema | undefined): string => {
  if (!data) {
    return ''
  }

  const lng: Languages = isLanguage(i18n.resolvedLanguage) ? i18n.resolvedLanguage : Languages.EN

  return data[lng] || ''
}

for (const contentInfo of configPrices.sort((a, b) => a.order - b.order)) {
  const content: TContent = {
    contentId: `content_${contentInfo.priceInternalId}`,
    internalPriceId: contentInfo.priceInternalId,
    preselected: contentInfo.preselected || false,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    name: translateBackendData(contentInfo.name),
    price: +contentInfo.basePriceAmount,
    currencySign: '$',
    currency: contentInfo.currency,
    discountPercentage: contentInfo.discountPercentage,
    crossedPrice: contentInfo.crossedPrice,
  }

  if (contentInfo.internalPlanId) {
    const plan = plans.find((p) => p.internalPlanId == contentInfo.internalPlanId)
    if (!plan) {
      console.warn('Invalid planId in content ' + content.internalPriceId)
    }
    content.planId = plan?.planId
  }

  contentDetails.push(content)
}
